import type * as all from 'weixin-js-sdk';

export const wxsdk = wx as unknown as typeof all.default;
